import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from '../../utils/axiosInstance';
import { toastSuccess, toastError, toastInfo } from '../../utils/alertHelper';

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post('/admin/api/user/login', {
        email,
        password,
      });
      

      const { Status, Message, UserToken, user, defaultCountry, defaultState, defaultCity } = response.data;
      if (Status === 1) {
        const userRole = user.roles?.[0]?.name || "";

        localStorage.setItem("email", user.email);
        localStorage.setItem("role", userRole);
        localStorage.setItem("token", UserToken);
        localStorage.setItem("defaultCountry", defaultCountry._id);
        localStorage.setItem("defaultState", defaultState._id);
        localStorage.setItem("defaultCity", defaultCity._id);
        localStorage.setItem("auth", "true");
        console.log(userRole);
        if (userRole === "SuperAdmin") {
          localStorage.setItem("auth", "true");
          toastSuccess("Login successful");
            navigate("/dashboard");
        } else {
          toastInfo("Redirecting to OTP");
            navigate("/otp");
        }
      } else {
        toastError("Invalid email or password");
      }
    } catch (error) {
      console.error(error);
        toastError("Something went wrong, please try again");
    }
  };

  return (
    <div className="">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="d-flex align-items-center justify-content-center min-vh-100">
                        <div className="w-50 d-block bg-white shadow-lg rounded my-5">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="p-5">
                                        <h1 className="h5 mb-1 text-center">Welcome Back!</h1>
                                        <p className="text-muted mb-4">Enter your email address and password to access admin panel.</p>
                                        <form onSubmit={handleLogin}>
                                            <div className="form-group">
                                                <input
                                                      type="email"
                                                      placeholder="Email Address"
                                                      onChange={(e) => setEmail(e.target.value)}
                                                      className="form-control form-control-user"
                                                      id="exampleInputEmail"
                                                      required
                                                    />
                                            </div>
                                            <div className="form-group">
                                                <input
                                                  type="password"
                                                  placeholder="Password"
                                                  onChange={(e) => setPassword(e.target.value)}
                                                  className="form-control form-control-user"
                                                    id="exampleInputPassword"
                                                  required
                                                />
                                            </div>
                                            <button type="submit" className="btn btn-success btn-block waves-effect waves-light">Log In</button>
                                        </form>

                                        {/* <div className="row mt-4">
                                            <div className="col-12 text-center">
                                                <p className="text-muted mb-2"><a href="auth-recoverpw.html" className="text-muted font-weight-medium ml-1">Forgot your password?</a></p>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default Login;


